
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 21 20","fill":"currentColor","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","d":"M2.817 8.398a.75.75 0 01.75-.75h13.867a.75.75 0 01.75.75v8.534a1.816 1.816 0 01-1.817 1.816H4.634a1.817 1.817 0 01-1.817-1.816V8.398zm1.5.75v7.784a.317.317 0 00.317.316h11.733a.317.317 0 00.317-.316V9.148H4.317z","clip-rule":"evenodd"}}),_c('path',{attrs:{"fill-rule":"evenodd","d":"M2.282 4.981c.34-.34.803-.532 1.285-.532h13.866a1.817 1.817 0 011.817 1.817v2.133a.75.75 0 01-.75.75h-16a.75.75 0 01-.75-.75V6.266c0-.482.191-.944.532-1.285zm1.285.968a.317.317 0 00-.317.317v1.383h14.5V6.266a.317.317 0 00-.317-.317H3.567z","clip-rule":"evenodd"}}),_c('path',{attrs:{"fill-rule":"evenodd","d":"M8.15 5.2a.75.75 0 01.75-.75h3.2a.75.75 0 01.75.75v3.2a.75.75 0 01-.75.75H8.9a.75.75 0 01-.75-.75V5.2zm1.5.75v1.7h1.7v-1.7h-1.7z","clip-rule":"evenodd"}}),_c('path',{attrs:{"fill-rule":"evenodd","d":"M6.77 1.47a.75.75 0 011.06 0l3.2 3.2a.75.75 0 11-1.06 1.06l-3.2-3.2a.75.75 0 010-1.06z","clip-rule":"evenodd"}}),_c('path',{attrs:{"fill-rule":"evenodd","d":"M14.23 1.47a.75.75 0 010 1.06l-3.2 3.2a.75.75 0 11-1.06-1.06l3.2-3.2a.75.75 0 011.06 0z","clip-rule":"evenodd"}})])
          )
        }
      }
    